import { AMNDivision } from "app/models/enums/AMNDivisionType";

export const isStrikOrder = ({ division, orderType }: { division?: string | null; orderType?: string | null }) => {
  return division?.toLowerCase() === AMNDivision.HSG.toLowerCase() && orderType?.toLowerCase() === 'strike';
};
